// removed by extract-text-webpack-plugin
module.exports = {"vpRichTextPromptContainer":"vpRichTextPromptContainer___1AJ9Q","vpRichTextPromptDisabled":"vpRichTextPromptDisabled___2dJ2u","vpRichTextEditButton":"vpRichTextEditButton___2B3I5","vpEditorDisabledOverlay":"vpEditorDisabledOverlay___2VX94","vpInvalidField":"vpInvalidField___u4xVs","vpInputError":"vpInputError___tNp-I","vpLoaderContainer":"vpLoaderContainer___1w7OG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignSuccess/RichText.module.less
// module id = 3866
// module chunks = 33